import image1 from "./service1.jpg";
import image2 from "./service2.jpg";
import image3 from "./service3.jpg";
import image4 from "./service4.jpg";

const services = [
  {
    title: "วางระบบไอทีแบบครบวงจร",
    description:
      "บริษัทฯ ให้บริการออกแบบและวางระบบคอมพิวเตอร์ที่เหมาะสมกับองค์กร โดยเริ่มตั้งแต่การวิเคราะห์ความต้องการ เลือกใช้อุปกรณ์ฮาร์ดแวร์และซอฟต์แวร์ที่เหมาะสม พัฒนาและติดตั้งระบบ พร้อมทั้งให้บริการอบรมผู้ใช้งาน จัดทำเอกสาร และดูแลระบบหลังการติดตั้ง เพื่อให้ระบบสามารถทำงานได้อย่างมีประสิทธิภาพและขยายตัวได้ในอนาคต",
    image: image1,
  },
  {
    title: "วางแผนระบบสารสนเทศเพื่อเพิ่มประสิทธิภาพ",
    description:
      "บริการนี้เน้นการวิเคราะห์ระบบงานที่มีอยู่เดิม เพื่อหาแนวทางในการเพิ่มผลผลิตและประสิทธิภาพขององค์กร บริษัทฯ จะช่วยปรับปรุงกระบวนการทำงานให้เป็นระบบ พร้อมทั้งเสนออุปกรณ์และซอฟต์แวร์ที่เหมาะสม วางแผนการใช้ทรัพยากรอย่างคุ้มค่า รวมถึงการป้องกันความเสี่ยง และการกำหนดกลยุทธ์การใช้สารสนเทศในองค์กรอย่างยั่งยืน    ",
    image: image2,
  },
  {
    title: "พัฒนาระบบตามความต้องการ",
    description:
      "บริษัทฯ ใช้กระบวนการพัฒนาระบบที่ทันสมัยและยืดหยุ่น โดยเริ่มจากการศึกษาและวิเคราะห์ความต้องการของลูกค้า วางแผนระบบอย่างเป็นขั้นตอน ออกแบบ สร้างต้นแบบ เขียนโปรแกรม ทดสอบ และแปลงข้อมูลเข้าสู่ระบบใหม่ พร้อมทั้งดำเนินการติดตั้ง อบรมผู้ใช้งาน และติดตามผลการใช้งานอย่างใกล้ชิด เพื่อให้ระบบสามารถตอบโจทย์การทำงานได้จริง",
    image: image4,
  },
  {
    title: "พัฒนาซอฟต์แวร์เฉพาะทาง",
    description:
      "บริษัทฯ รับพัฒนาซอฟต์แวร์ที่ออกแบบเฉพาะสำหรับธุรกิจแต่ละประเภท เช่น ซอฟต์แวร์จัดการข้อมูล ซอฟต์แวร์สื่อสารภายในองค์กร หรือระบบที่ช่วยเพิ่มประสิทธิภาพในการผลิต โดยครอบคลุมทั้งการพัฒนาซอฟต์แวร์ใหม่ การปรับเปลี่ยนให้สามารถทำงานข้ามระบบปฏิบัติการ และการนำซอฟต์แวร์สำเร็จรูปมาปรับใช้งานเฉพาะด้านตามความต้องการของลูกค้า",
    image: image3,
  },
  {
    title: "ที่ปรึกษาด้านไอที สิ่งแวดล้อม และมาตรฐานองค์กร",
    description:
      "บริษัทฯ ให้บริการที่ปรึกษาอย่างครบวงจรในด้านเทคโนโลยีสารสนเทศ การบริหารจัดการสิ่งแวดล้อม และการยกระดับมาตรฐานองค์กร โดยเน้นการพัฒนาอย่างยั่งยืนและสอดคล้องกับมาตรฐานสากล ทีมที่ปรึกษาของบริษัทมีประสบการณ์และความเชี่ยวชาญในการวิเคราะห์ปัญหา เสนอแนวทางแก้ไข และวางกลยุทธ์เพื่อช่วยให้องค์กรทันสมัย มีประสิทธิภาพ และได้รับความเชื่อมั่นจากผู้มีส่วนเกี่ยวข้อง",
    image: image4,
  },
];

export default services;
